<pbc-sorter [config]="HerausgebersSorterConfig" [sorter]="herausgebers.sorter$ | async" (sorterChange)="herausgebers.sorter$.next($event)"></pbc-sorter>
